
const PASSWORD_SUB = 'password'

export default {
  name: 'SetupSidebar',
  props: {
    /** 账号页当前子面板：0 账号概览，2 修改密码（仅 /setup 使用） */
    accountSub: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      routeItems: [
        { path: '/setup/blacklist', titleKey: 'page.BLACKLIST_MANAGEMENT', icon: 'icon-eye-off' },
        { path: '/setup/thirdBinding', titleKey: 'page.THIRD_PARTY_BINDING', icon: 'icon-unlink' },
        { path: '/setup/inviteFriends', titleKey: 'page.INVITE_FRIENDS', icon: 'icon-message-share' },
        { path: '/setup/feedback', titleKey: 'page.FEEDBACK', icon: 'icon-report-search' },
      ],
    }
  },
  computed: {
    isSetupHome() {
      return this.$route.path === '/setup' || this.$route.path === '/setup/'
    },
    /** 桌面端仅在账号页展开「修改密码」子项 */
    showPasswordSub() {
      return this.isSetupHome
    },
    isPasswordActive() {
      return this.isSetupHome && (this.accountSub === 2 || this.$route.query.sub === PASSWORD_SUB)
    },
    isAccountActive() {
      return this.isSetupHome && !this.isPasswordActive
    },
  },
  mounted() {
    this.$nextTick(() => this.scrollActiveTabIntoView())
  },
  watch: {
    '$route.fullPath'() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },
    accountSub() {
      this.$nextTick(() => this.scrollActiveTabIntoView())
    },
  },
  methods: {
    isPathActive(path) {
      return this.$route.path === path || this.$route.path === `${path}/`
    },
    onAccountClick() {
      this.$emit('update:accountSub', 0)
    },
    goAccount() {
      if (this.isSetupHome) {
        this.$emit('update:accountSub', 0)
        if (this.$route.query.sub) {
          this.$router.replace({ path: '/setup' }).catch(() => {})
        }
        return
      }
      this.$router.push({ path: '/setup' })
    },
    goPassword() {
      this.$emit('update:accountSub', 2)
      if (this.isSetupHome) {
        if (this.$route.query.sub !== PASSWORD_SUB) {
          this.$router.replace({ path: '/setup', query: { sub: PASSWORD_SUB } }).catch(() => {})
        }
        return
      }
      this.$router.push({ path: '/setup', query: { sub: PASSWORD_SUB } })
    },
    /** 手机端把当前 Tab 滚入可视区 */
    scrollActiveTabIntoView() {
      if (!process.client) return
      const wrap = this.$refs.mobileTabs
      if (!wrap) return
      const active = wrap.querySelector('.is-active')
      if (active && typeof active.scrollIntoView === 'function') {
        active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
      }
    },
  },
}
